'use client';

import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css, Global } from '@emotion/react';
import { DefaultFontFamily, DirittoImageEditorBodyStyle } from 'libs/DirittoImageEditorStyle';
import { fonts } from 'styles/fonts';

const styles = css`
  ${fonts}
  body {
    padding: 0;
    margin: 0;

    word-break: keep-all;
    word-wrap: break-word;

    font-style: normal;
    font-weight: ${FontWeight.Medium};
    ${Typography.XSmall};
    ${DefaultFontFamily};
  }

  ${DirittoImageEditorBodyStyle}
  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  p {
    margin: 0;
  }

  img {
    object-fit: cover;
    max-width: 100%;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  // Safari 에서 input 안되는 문제 수정
  input,
  textarea {
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  button {
    font-family: inherit;
    cursor: pointer;
    color: inherit;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    outline: none;
  }

  div[data-youtube-video] > iframe {
    border: none;
    cursor: move;
    aspect-ratio: 16 / 9;
    width: 100%;
    height: auto;
  }

  * {
    box-sizing: border-box;
    font-size: inherit;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  :root {
    /* iOS 11.0 버전 */
    --safe-area-top-old: constant(safe-area-inset-top);
    --safe-area-right-old: constant(safe-area-inset-right);
    --safe-area-bottom-old: constant(safe-area-inset-bottom);
    --safe-area-left-old: constant(safe-area-inset-left);

    /* iOS 11.2 이상 */
    --safe-area-top: env(safe-area-inset-top);
    --safe-area-right: env(safe-area-inset-right);
    --safe-area-bottom: env(safe-area-inset-bottom);
    --safe-area-left: env(safe-area-inset-left);
  }
`;

export const GlobalStyle = () => <Global styles={styles} />;
